module.exports = __webpack_public_path__ + "img/selected_pin_feeler.9c3ce56f.svg";